// extracted by mini-css-extract-plugin
export default {"digit":"DigitCounter_digit__2XQLc"};